<template>
  <section id="projects" class="projects">
    <h2>{{ $t("Home.privateProjects") }}</h2>
    <div ref="listEl" class="projects__container reveal-on-scroll">
      <JroProjectNew
        year="2026"
        :inProgress="true"
        :title="$t('Projects.bautb.title')"
        image="images/bautb.jpeg"
        :subtitle="$t('Projects.bautb.subtitle')"
        :action="$t('Projects.bautb.action')"
        :link="$t('Projects.bautb.link')"
      />

      <JroProjectNew
        year="2024"
        :title="$t('Projects.wingspan.title')"
        image="images/wingspan.jpeg"
        :subtitle="$t('Projects.wingspan.subtitle')"
        :action="$t('Projects.wingspan.action')"
        :link="$t('Projects.wingspan.link')"
      />

      <JroProjectNew
        year="2023"
        :title="$t('Projects.vrgames.title')"
        image="images/vrgame.jpeg"
        :subtitle="$t('Projects.vrgames.subtitle')"
        :action="$t('Projects.vrgames.action')"
        :link="$t('Projects.vrgames.link')"
      />

      <JroProjectNew
        year="2023"
        :inProgress="true"
        :title="$t('Projects.homeautomation.title')"
        image="images/homeautomation.jpeg"
        :subtitle="$t('Projects.homeautomation.subtitle')"
      />

      <JroProjectNew
        year="2022"
        :title="$t('Projects.mediaOrga.title')"
        image="images/mediaOrga.jpg"
        :subtitle="$t('Projects.mediaOrga.subtitle')"
        :action="$t('Projects.mediaOrga.action')"
        :link="$t('Projects.mediaOrga.link')"
      />

      <JroProjectNew
        year="2019"
        :title="$t('Projects.hhb.title')"
        :subtitle="$t('Projects.hhb.subtitle')"
        :action="$t('Projects.hhb.action')"
        :link="$t('Projects.hhb.link')"
      />

      <JroProjectNew
        year="2019"
        :title="$t('Projects.logger.title')"
        :subtitle="$t('Projects.logger.subtitle')"
        :action="$t('Projects.logger.action')"
        :link="$t('Projects.logger.link')"
      />

      <JroProjectNew
        year="2018"
        :title="$t('Projects.leanCanvas.title')"
        image="images/leanCanvas.jpg"
        :subtitle="$t('Projects.leanCanvas.subtitle')"
        :action="$t('Projects.leanCanvas.action')"
        :link="$t('Projects.leanCanvas.link')"
      />

      <JroProjectNew
        year="2017"
        :title="$t('Projects.visualObserver.title')"
        image="images/observer.jpg"
        :subtitle="$t('Projects.visualObserver.subtitle')"
        :action="$t('Projects.visualObserver.action')"
        :link="$t('Projects.visualObserver.link')"
      />

      <JroProjectNew
        year="2014"
        :title="$t('Projects.headphones.title')"
        image="images/master.jpg"
        :subtitle="$t('Projects.headphones.subtitle')"
        :action="$t('Projects.headphones.action')"
        :link="$t('Projects.headphones.link')"
      />

      <JroProjectNew
        year="2013"
        :title="$t('Projects.weatherStation.title')"
        :subtitle="$t('Projects.weatherStation.subtitle')"
        :action="$t('Projects.weatherStation.action')"
        :link="$t('Projects.weatherStation.link')"
      />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import JroProjectNew from "@/components/JroProjectNew.vue";
import { useRevealOnScroll } from "@/composables/useRevealOnScroll";

export default defineComponent({
  name: "JroProjectsNew",
  components: {
    JroProjectNew,
  },
  setup() {
    const listEl = ref<HTMLElement | null>(null);
    useRevealOnScroll(listEl);
    return { listEl };
  },
});
</script>

<style lang="scss" scoped>
@use "../global.scss" as *;

.projects {
  padding: 4rem 1.5rem 6rem;
}

.projects__container {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  max-width: 72rem;
  margin: 0 auto;

  @media (min-width: $bp-large) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1.5rem;
    align-items: stretch;
    container-type: inline-size;
  }

  @media (min-width: $bp-largest) {
    gap: 1.75rem;
  }
}
</style>
